import { useState } from "react";
import {
  useFloating,
  useHover,
  useInteractions,
  useDismiss,
  useClick,
} from "@floating-ui/react";
import ListSection from "./ListSection";
import { MdFactCheck } from "react-icons/md";
import styles from "./KeyFacts.module.scss";
import SectionTitle from "./SectionTitle";
import { CldImage } from "next-cloudinary";

export default function KeyFacts({ facts }) {
  const ignoreFacts = ["__typename", "time_zone_offset", "currency_code"];
  const entries = Object.entries(facts).filter(
    (entry) => !ignoreFacts.includes(entry[0]) && !entry[1]?.includes("null")
  );

  const factElements = entries.map((entry, index) => {
    return (
      <Fact
        name={entry[0].replace("_", " ")}
        fact={entry[1]}
        key={`${entry[0]}-${index}`}
      />
    );
  });

  return (
    <>
      <SectionTitle title="Key Facts" icon={<MdFactCheck size={34} />} />

      <ListSection
        id="key-facts-section"
        itemType="component"
        items={factElements}
        listStyle="bullet"
      />
    </>
  );
}

function Fact({ name, fact }) {
  if (!fact) return null;

  return (
    <li className={`${styles.fact}`}>
      <span className={`${styles.label}`}>{name}: </span>
      <span className={`${styles.text}`}>{fact}</span>
      {["electricity"].includes(name) && <FactToolTip name={name} />}
    </li>
  );
}

function FactToolTip({ name }) {
  const [isOpen, setIsOpen] = useState(false);
  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
  });

  const hover = useHover(context);
  const click = useClick(context);
  const dismiss = useDismiss(context, {
    referencePress: true,
    bubbles: true,
  });

  const { getReferenceProps, getFloatingProps } = useInteractions([
    hover,
    click,
    dismiss,
  ]);

  const tooltipContent = {
    electricity: <ElectricityTooltipContent />,
  };

  return (
    <>
      <span
        ref={refs.setReference}
        {...getReferenceProps}
        className={`${styles.tooltipReference}`}
      >
        ?
      </span>
      {isOpen && (
        <div
          className={`${styles.tooltip}`}
          ref={refs.setFloating}
          style={floatingStyles}
          {...getFloatingProps}
        >
          {tooltipContent[name]}
        </div>
      )}
    </>
  );
}

function ElectricityTooltipContent({}) {
  return (
    <CldImage
      src="https://res.cloudinary.com/dail4fbms/image/upload/v1706012630/plug_types_610c2a4219.png"
      width="450"
      height="360"
      style={{ maxWidth: "300px" }}
      alt="Plug types diagram"
    />
  );
}
